import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ViewBasePage } from '@shared/pages';
// import { VideosService } from '@shared/services';
import { Constants } from '@shared/models';
import type { TVideo } from '@shared/models';

@Component({
    'selector': 'app-tutorials',
    'templateUrl': './tutorials.page.html',
    'styleUrls': ['./tutorials.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class TutorialsPage extends ViewBasePage implements OnInit {
    public tutorials: TVideo[] = [];
    public page = 1;
    public count = null;

    // private videosService: VideosService, 
    constructor(private domSanitizer: DomSanitizer, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_TUTORIALS);
    }

    public override async ngOnInit(): Promise<void> {
        // const role = this.sessionService.getCurrentUser().role;
        // this.tutorials = await this.videosService.getVideosForAudience(role);
        this.initMoreMenu();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tour', 'show-tutorials-tour');
    }
}

//     // {'title': 'West Wing - Get the Popcorn', 'video': 'https://www.youtube.com/embed/D93295KpIZw',
//          'description': '1 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
//          industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type
//          and scrambled it to make a type specimen book.'},
//     // {'title': 'West Wing - Leo Interviews Ainsley', 'video': 'https://www.youtube.com/embed/DUwm6WJRPIQ',
//          'description': '2 Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
//          industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type
//          and scrambled it to make a type specimen book.'}
//     // ];
//     public videos: any[];
// }
